module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: _vm._css
  }, [_c('label', {
    staticClass: "col-sm-12 control-label"
  }, [_vm._v(_vm._s(_vm._title))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._t("default", [_c('input', {
    staticClass: "form-control",
    attrs: {
      "required": "required"
    }
  })])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc05f3ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-input.vue
// module id = 463
// module chunks = 0